import { CSSObject } from "@emotion/react";
import {
  constants,
  type ButtonStyleOverrides,
  AngelouCSS,
} from "@newsela/angelou";

export const getSortByButtonOptionCss = (
  isSelected: boolean,
): ButtonStyleOverrides<AngelouCSS> => ({
  root: {
    padding: "8px 16px",
    width: "100%",
    height: "40px",
    borderRadius: 0,
    textWrap: "nowrap",

    color: isSelected
      ? constants.colors.ui.neutral[700]
      : constants.colors.ui.neutral[500],

    background: isSelected
      ? constants.colors.ui.neutral[25]
      : constants.colors.ui.white[25],

    ":hover": {
      background: "rgb(29, 29, 29, .08)",
    },
  },
});

export const buttonContainerCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  position: "relative",

  "div:has(> button)": {
    width: "100%",
  },
};

export const buttonWithPopoutCss = {
  Button: {
    root: {
      display: "flex",
      justifyContent: "space-between",
      minWidth: "203px",
      textWrap: "nowrap",
      padding: "4px 8px",

      "&, &:hover": {
        color: constants.colors.ui.core[700],
      },

      path: {
        strokeWidth: "4px",
      },
    },
  },

  PopOut: {
    root: {
      zIndex: 5,
    },
  },
};

export const selectedOptionIndicatorCss: CSSObject = {
  position: "absolute",
  left: "4px",
  height: "32px",
  width: "4px",
  zIndex: 1,
  background: constants.colors.ui.core[700],
  borderRadius: "2px",
};

export const popoutContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "16px 0",
  gap: "8px",
  borderRadius: "8px",
  background: constants.colors.ui.white[50],
  width: "204px",
};
